import React from "react"
import DeleteFilter from "../../../../../assets/iconos/close.svg";


class Segment extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            listSegment         : [],
            segmentActive       : {},
            load_complete       : " hide"
        }
        this.getDefaultValues = this.getDefaultValues.bind(this);
    }
    getDefaultValues(){
        return {
            listSegment: [],
            segmentActive: {},
            load_complete: " hide"
        };
    }
    handleSegmentFilter(id){
        let self = this;
        let segmentActive    = this.state.segmentActive;
        let not_exist = (segmentActive[id] === undefined) ? true : false;
        let status  =  "inactive";

        this.setState(function(){
            if(not_exist === true){
                segmentActive[id] = id
            }else if(not_exist === false){
                delete segmentActive[id]
            }
            status  =  (Object.keys(segmentActive).length > 0) ? "active" : "inactive";
            return {
                segmentActive : segmentActive,
            }
        }, function(){
            self.props.getChannels(status, segmentActive);
        });
    }
    
    
    updateComponent(){ 
        //this.forceUpdate(); 
    }

    render(){
        let wdg_aux     = this.props.layout.state.statics;
        if(Object.keys(wdg_aux).length > 0)
        {
            let key_times     = this.props.layout.state.key_time;
            if(key_times !== undefined){
                this.state.listSegment = Object.keys(wdg_aux).map((filt_aux, index_aux) => {
                   // if(wdg_aux[filt_aux].num_reservations !== 0){

                        let wdg  = Object.assign({}, wdg_aux[filt_aux]["segments"]);
                        if(key_times[filt_aux] !== undefined){
                            wdg["totals"] = "totals";
                            let childs =  Object.keys(wdg).map((filt, index) => {
                                if(filt !== "totals"){
                                    const props = {
                                        style : (this.state.segmentActive[wdg[filt]._id] !== undefined) ? wdg[filt].cssStyle : {},
                                        key : "filter-listsegment-"+index,
                                        className : index%2 ? "row-c" : ""
                                    }
                                    const props_row = {
                                        style : (this.state.segmentActive[wdg[filt]._id] !== undefined) ? wdg[filt].cssStyle : {},
                                        onClick : this.handleSegmentFilter.bind(this, wdg[filt]._id), 
                                        className : "filter-row " + (this.state.segmentActive[wdg[filt]._id] ? "active" : "inactive"), 
                                    }
                                    return (<div {...props}>
                                                <div style={(this.state.segmentActive[wdg[filt]._id] !== undefined) ? wdg[filt].cssStyle : {}}>
                                                    <span className="segment-filter">{ wdg[filt].name }</span> 
                                                    <span {...props_row}/>
                                                </div>
                                            </div>);
                                }else{
                                    return (<div className="totals">
                                    <div>
                                        <span className="segment-filter">TOTAL</span> 
                                    </div>
                                </div>)
                                }
                            })
                            return <div ref={(e) => {this["major-segment-" + filt_aux] = e }} className="major-segment" children={childs} />
                        }else{
                            return (<div ref={(e) => {this["major-segment-" + filt_aux] = e }} className={ index_aux%2 ? "row-c" : "" } />)
                        }
                    //}
                })
            }
        }
        return (
            <div className={"datagrid-widget by-segment show-widget complete " + this.props.layout.state.filter_month_active}>
                <div className="container-fluid">
                    <div className="row header-widget">
                        <div className="col-md-12 options-widget">
                            <span className="title">SEGMENTO</span>
                        </div>
                    </div>
                    <div className="current-values">
                        <div className="row">
                            <div className="col-md-12 head-current">
                                <input className="text-search-widget" placeholder="Search..." type="text" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 datagrid-list">
                                { this.state.listSegment }
                                <div className={"datagrid-month totals"}>
                                    <div> </div>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div>
            </div>
        )
    }
}

export default Segment



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/occupancy/views/Production/Segment.js